export type DocumentStatus = 'DRAFT' | 'ACTIVE' | 'COMPLETED' | 'CANCELLED' | 'EXPIRED';
export type SignerStatus = 'PENDING' | 'INVITED' | 'SIGNED' | 'REJECTED' | 'EXPIRED';
export type SignatureType = 'QUALIFIED' | 'ADVANCED' | 'SIMPLE';
export type SendMode = 'SEQUENTIAL' | 'SIMULTANEOUS';
export type DocType = 'CPF' | 'CNPJ';

export interface Signer {
  id: string;
  documentId: string;
  order: number;
  name: string;
  email: string;
  docType: DocType;
  docNumber: string;
  signatureType: SignatureType;
  requestTimestamp: string;
  status: SignerStatus;
  signedAt: string | null;
  signatureId: string | null;
  expiresAt: string;
  inviteToken: string;
  timestampRequested: boolean;
}

export interface Document {
  id: string;
  title: string;
  description: string;
  uploadedBy: string;
  createdAt: string;
  status: DocumentStatus;
  sendMode: SendMode;
  signers: Signer[];
  pages: number;
  fileSizeKb: number;
}

export interface AuditEntry {
  id: string;
  documentId: string;
  signerId: string | null;
  action: string;
  timestamp: string;
  details: string;
  actor: string;
}

export const mockDocuments: Document[] = [
  {
    id: 'doc-001',
    title: 'Contrato de Prestação de Serviços — TechBrasil Ltda',
    description: 'Contrato anual de desenvolvimento de software e manutenção de sistemas.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-25T09:14:00Z',
    status: 'ACTIVE',
    sendMode: 'SEQUENTIAL',
    pages: 12,
    fileSizeKb: 842,
    signers: [
      {
        id: 'sgn-001',
        documentId: 'doc-001',
        order: 1,
        name: 'Fernanda Oliveira Santos',
        email: 'fernanda.santos@techbrasil.com.br',
        docType: 'CPF',
        docNumber: '45678912300',
        signatureType: 'QUALIFIED',
        requestTimestamp: '2026-04-25T09:15:00Z',
        status: 'SIGNED',
        signedAt: '2026-04-25T14:32:00Z',
        signatureId: 'sig-a1b2c3',
        expiresAt: '2026-05-25T09:15:00Z',
        inviteToken: 'tok-001-abc',
        timestampRequested: true,
      },
      {
        id: 'sgn-002',
        documentId: 'doc-001',
        order: 2,
        name: 'Ricardo Mendes Carvalho',
        email: 'rmendes@techbrasil.com.br',
        docType: 'CPF',
        docNumber: '78945612301',
        signatureType: 'ADVANCED',
        requestTimestamp: '2026-04-25T14:33:00Z',
        status: 'INVITED',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-05-25T14:33:00Z',
        inviteToken: 'tok-002-def',
        timestampRequested: false,
      },
      {
        id: 'sgn-003',
        documentId: 'doc-001',
        order: 3,
        name: 'Juliana Costa Ferreira',
        email: 'juliana.cf@techbrasil.com.br',
        docType: 'CPF',
        docNumber: '12365478900',
        signatureType: 'SIMPLE',
        requestTimestamp: '',
        status: 'PENDING',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-05-25T14:33:00Z',
        inviteToken: 'tok-003-ghi',
        timestampRequested: false,
      },
    ],
  },
  {
    id: 'doc-002',
    title: 'Aditivo Contratual — Renovação Licença Software',
    description: 'Aditivo ao contrato principal para renovação de licenças por mais 12 meses.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-22T11:00:00Z',
    status: 'COMPLETED',
    sendMode: 'SIMULTANEOUS',
    pages: 4,
    fileSizeKb: 312,
    signers: [
      {
        id: 'sgn-004',
        documentId: 'doc-002',
        order: 1,
        name: 'Marcos Vinícius Almeida',
        email: 'marcos.almeida@empresa.com.br',
        docType: 'CPF',
        docNumber: '98765432100',
        signatureType: 'QUALIFIED',
        requestTimestamp: '2026-04-22T11:05:00Z',
        status: 'SIGNED',
        signedAt: '2026-04-23T10:15:00Z',
        signatureId: 'sig-d4e5f6',
        expiresAt: '2026-05-22T11:05:00Z',
        inviteToken: 'tok-004-jkl',
        timestampRequested: true,
      },
      {
        id: 'sgn-005',
        documentId: 'doc-002',
        order: 2,
        name: 'Patrícia Souza Lima',
        email: 'patricia.lima@empresa.com.br',
        docType: 'CPF',
        docNumber: '65432198700',
        signatureType: 'ADVANCED',
        requestTimestamp: '2026-04-22T11:05:00Z',
        status: 'SIGNED',
        signedAt: '2026-04-23T16:44:00Z',
        signatureId: 'sig-g7h8i9',
        expiresAt: '2026-05-22T11:05:00Z',
        inviteToken: 'tok-005-mno',
        timestampRequested: false,
      },
    ],
  },
  {
    id: 'doc-003',
    title: 'NDA — Acordo de Confidencialidade Parceria Estratégica',
    description: 'Acordo de não divulgação para início de negociações com parceiro estratégico.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-20T15:30:00Z',
    status: 'EXPIRED',
    sendMode: 'SIMULTANEOUS',
    pages: 6,
    fileSizeKb: 524,
    signers: [
      {
        id: 'sgn-006',
        documentId: 'doc-003',
        order: 1,
        name: 'Eduardo Pinheiro Ramos',
        email: 'eduardo.ramos@parceiroXYZ.com',
        docType: 'CNPJ',
        docNumber: '12345678000195',
        signatureType: 'SIMPLE',
        requestTimestamp: '2026-04-20T15:35:00Z',
        status: 'EXPIRED',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-04-27T15:35:00Z',
        inviteToken: 'tok-006-pqr',
        timestampRequested: false,
      },
    ],
  },
  {
    id: 'doc-004',
    title: 'Proposta Comercial — Consultoria Fiscal Q2 2026',
    description: 'Proposta de serviços de consultoria fiscal para o segundo trimestre de 2026.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-26T08:00:00Z',
    status: 'ACTIVE',
    sendMode: 'SEQUENTIAL',
    pages: 8,
    fileSizeKb: 680,
    signers: [
      {
        id: 'sgn-007',
        documentId: 'doc-004',
        order: 1,
        name: 'Camila Rodrigues Nunes',
        email: 'camila.nunes@consultfiscal.com.br',
        docType: 'CPF',
        docNumber: '32165498700',
        signatureType: 'ADVANCED',
        requestTimestamp: '2026-04-26T08:05:00Z',
        status: 'INVITED',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-04-30T08:05:00Z',
        inviteToken: 'tok-007-stu',
        timestampRequested: true,
      },
      {
        id: 'sgn-008',
        documentId: 'doc-004',
        order: 2,
        name: 'André Luís Tavares',
        email: 'andre.tavares@consultfiscal.com.br',
        docType: 'CPF',
        docNumber: '74185296300',
        signatureType: 'SIMPLE',
        requestTimestamp: '',
        status: 'PENDING',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-04-30T08:05:00Z',
        inviteToken: 'tok-008-vwx',
        timestampRequested: false,
      },
    ],
  },
  {
    id: 'doc-005',
    title: 'Termo de Uso — Plataforma Digital Interna',
    description: 'Aceite dos termos de uso para acesso à plataforma interna corporativa.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-24T13:00:00Z',
    status: 'ACTIVE',
    sendMode: 'SIMULTANEOUS',
    pages: 3,
    fileSizeKb: 218,
    signers: [
      {
        id: 'sgn-009',
        documentId: 'doc-005',
        order: 1,
        name: 'Beatriz Helena Moura',
        email: 'beatriz.moura@corp.com.br',
        docType: 'CPF',
        docNumber: '95175385300',
        signatureType: 'SIMPLE',
        requestTimestamp: '2026-04-24T13:05:00Z',
        status: 'SIGNED',
        signedAt: '2026-04-24T18:22:00Z',
        signatureId: 'sig-j0k1l2',
        expiresAt: '2026-05-24T13:05:00Z',
        inviteToken: 'tok-009-yza',
        timestampRequested: false,
      },
      {
        id: 'sgn-010',
        documentId: 'doc-005',
        order: 2,
        name: 'Gabriel Henrique Souza',
        email: 'gabriel.souza@corp.com.br',
        docType: 'CPF',
        docNumber: '15935785200',
        signatureType: 'SIMPLE',
        requestTimestamp: '2026-04-24T13:05:00Z',
        status: 'INVITED',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-05-24T13:05:00Z',
        inviteToken: 'tok-010-bcd',
        timestampRequested: false,
      },
      {
        id: 'sgn-011',
        documentId: 'doc-005',
        order: 3,
        name: 'Larissa Andrade Pereira',
        email: 'larissa.pereira@corp.com.br',
        docType: 'CPF',
        docNumber: '75395185100',
        signatureType: 'SIMPLE',
        requestTimestamp: '2026-04-24T13:05:00Z',
        status: 'REJECTED',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-05-24T13:05:00Z',
        inviteToken: 'tok-011-efg',
        timestampRequested: false,
      },
    ],
  },
  {
    id: 'doc-006',
    title: 'Contrato Social — Alteração de Quadro Societário',
    description: 'Alteração contratual para inclusão de novo sócio com participação de 20%.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-18T10:00:00Z',
    status: 'CANCELLED',
    sendMode: 'SEQUENTIAL',
    pages: 15,
    fileSizeKb: 1240,
    signers: [
      {
        id: 'sgn-012',
        documentId: 'doc-006',
        order: 1,
        name: 'Roberto Carlos Figueiredo',
        email: 'roberto.figueiredo@juridico.com.br',
        docType: 'OAB',
        docNumber: '78541236900',
        signatureType: 'QUALIFIED',
        requestTimestamp: '2026-04-18T10:05:00Z',
        status: 'SIGNED',
        signedAt: '2026-04-19T09:00:00Z',
        signatureId: 'sig-m3n4o5',
        expiresAt: '2026-05-18T10:05:00Z',
        inviteToken: 'tok-012-hij',
        timestampRequested: true,
      },
    ],
  },
  {
    id: 'doc-007',
    title: 'Acordo de Nível de Serviço — Infraestrutura Cloud',
    description: 'SLA para serviços de cloud computing com garantias de uptime e suporte.',
    uploadedBy: 'user-001',
    createdAt: '2026-04-27T16:00:00Z',
    status: 'ACTIVE',
    sendMode: 'SEQUENTIAL',
    pages: 9,
    fileSizeKb: 756,
    signers: [
      {
        id: 'sgn-013',
        documentId: 'doc-007',
        order: 1,
        name: 'Thiago Alves Monteiro',
        email: 'thiago.monteiro@cloudprovider.com.br',
        docType: 'CNPJ',
        docNumber: '98765432000101',
        signatureType: 'QUALIFIED',
        requestTimestamp: '2026-04-27T16:05:00Z',
        status: 'INVITED',
        signedAt: null,
        signatureId: null,
        expiresAt: '2026-04-29T16:05:00Z',
        inviteToken: 'tok-013-klm',
        timestampRequested: true,
      },
    ],
  },
];

export const mockAuditLog: AuditEntry[] = [
  {
    id: 'audit-001',
    documentId: 'doc-001',
    signerId: null,
    action: 'DOCUMENT_CREATED',
    timestamp: '2026-04-25T09:14:00Z',
    details: 'Documento criado e configurado para assinatura sequencial com 3 signatários.',
    actor: 'Ana Paula Vieira',
  },
  {
    id: 'audit-002',
    documentId: 'doc-001',
    signerId: 'sgn-001',
    action: 'INVITE_SENT',
    timestamp: '2026-04-25T09:15:00Z',
    details: 'Convite de assinatura enviado para fernanda.santos@techbrasil.com.br',
    actor: 'Sistema',
  },
  {
    id: 'audit-003',
    documentId: 'doc-001',
    signerId: 'sgn-001',
    action: 'DOCUMENT_SIGNED',
    timestamp: '2026-04-25T14:32:00Z',
    details: 'Assinatura qualificada ICP-Brasil coletada. ID: sig-a1b2c3. Carimbo de tempo aplicado.',
    actor: 'Fernanda Oliveira Santos',
  },
  {
    id: 'audit-004',
    documentId: 'doc-001',
    signerId: 'sgn-002',
    action: 'INVITE_SENT',
    timestamp: '2026-04-25T14:33:00Z',
    details: 'Convite de assinatura enviado para rmendes@techbrasil.com.br (modo sequencial)',
    actor: 'Sistema',
  },
  {
    id: 'audit-005',
    documentId: 'doc-001',
    signerId: 'sgn-002',
    action: 'INVITE_RESENT',
    timestamp: '2026-04-27T10:00:00Z',
    details: 'Convite reenviado manualmente pelo solicitante.',
    actor: 'Ana Paula Vieira',
  },
  {
    id: 'audit-006',
    documentId: 'doc-001',
    signerId: 'sgn-002',
    action: 'DEADLINE_CHANGED',
    timestamp: '2026-04-27T10:02:00Z',
    details: 'Prazo de expiração alterado de 25/05/2026 para 02/05/2026.',
    actor: 'Ana Paula Vieira',
  },
  {
    id: 'audit-007',
    documentId: 'doc-001',
    signerId: null,
    action: 'PARTIAL_PDF_DOWNLOADED',
    timestamp: '2026-04-28T08:15:00Z',
    details: 'PDF parcialmente assinado baixado pelo solicitante.',
    actor: 'Ana Paula Vieira',
  },
];

export const mockUser = {
  id: 'user-001',
  name: 'Ana Paula Vieira',
  email: 'ana.vieira@rd2sign.com.br',
  company: 'RD2Buzz',
  plan: 'Business',
};

export function getSignedCount(doc: Document): number {
  return doc.signers.filter(s => s.status === 'SIGNED').length;
}

export function getDocumentStatusLabel(status: DocumentStatus): string {
  const map: Record<DocumentStatus, string> = {
    DRAFT: 'Rascunho',
    ACTIVE: 'Aguardando',
    COMPLETED: 'Concluído',
    CANCELLED: 'Cancelado',
    EXPIRED: 'Expirado',
  };
  return map[status];
}

export function getSignerStatusLabel(status: SignerStatus): string {
  const map: Record<SignerStatus, string> = {
    PENDING: 'Aguardando envio',
    INVITED: 'Convite enviado',
    SIGNED: 'Assinado',
    REJECTED: 'Recusado',
    EXPIRED: 'Expirado',
  };
  return map[status];
}

export function getSignatureTypeLabel(type: SignatureType): string {
  const map: Record<SignatureType, string> = {
    QUALIFIED: 'Qualificada (ICP-Brasil)',
    ADVANCED: 'Avançada (RD2Buzz)',
    SIMPLE: 'Simples (Manuscrita)',
  };
  return map[type];
}

export function formatDate(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateTime(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

// CPF validation
export function validateCPF(cpf: string): boolean {
  const cleaned = cpf.replace(/\D/g, '');
  if (cleaned.length !== 11) return false;
  if (/^(\d)\1+$/.test(cleaned)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cleaned[i]) * (10 - i);
  let remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleaned[9])) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cleaned[i]) * (11 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  return remainder === parseInt(cleaned[10]);
}

// CNPJ validation — supports both legacy numeric and new alphanumeric format (Receita Federal, July 2026)
// Algorithm: each char value = charCode - 48 (digits: 0-9 → 0-9; letters A-Z → 17-42)
// Weights 2-9 distributed right-to-left over the 12 base chars, cycling after 8th.
// DV rule: remainder 0 or 1 → digit = 0; else digit = 11 - remainder.
export function validateCNPJ(cnpj: string): boolean {
  // Strip formatting characters (dots, slashes, hyphens) but keep letters and digits
  const cleaned = cnpj.replace(/[.\-\/]/g, '').toUpperCase().trim();

  if (cleaned.length !== 14) return false;

  // The first 12 chars are alphanumeric; the last 2 must be digits (check digits)
  const base = cleaned.slice(0, 12);
  const dv1Char = cleaned[12];
  const dv2Char = cleaned[13];

  // Check digits must be numeric
  if (!/^\d$/.test(dv1Char) || !/^\d$/.test(dv2Char)) return false;

  // Reject all-same-character sequences (e.g. "00000000000000")
  if (/^(.)\1+$/.test(cleaned)) return false;

  // Validate that base chars are only digits or uppercase letters
  if (!/^[0-9A-Z]{12}$/.test(base)) return false;

  // Convert a character to its numeric value for DV calculation (ASCII - 48)
  const charVal = (c: string): number => c.charCodeAt(0) - 48;

  // Calculate a check digit given the base string and weights starting at weightStart
  const calcDV = (chars: string): number => {
    const weights = [2, 3, 4, 5, 6, 7, 8, 9];
    let sum = 0;
    // Weights are distributed right-to-left, cycling 2-9
    for (let i = 0; i < chars.length; i++) {
      const weightIndex = (chars.length - 1 - i) % weights.length;
      sum += charVal(chars[i]) * weights[weightIndex];
    }
    const rem = sum % 11;
    return rem < 2 ? 0 : 11 - rem;
  };

  const dv1 = calcDV(base);
  if (dv1 !== parseInt(dv1Char, 10)) return false;

  const dv2 = calcDV(base + dv1Char);
  if (dv2 !== parseInt(dv2Char, 10)) return false;

  return true;
}

export const chartData = [
  { day: '01/04', enviados: 3, assinados: 2, recusados: 0 },
  { day: '05/04', enviados: 5, assinados: 4, recusados: 1 },
  { day: '08/04', enviados: 2, assinados: 1, recusados: 0 },
  { day: '10/04', enviados: 7, assinados: 6, recusados: 0 },
  { day: '12/04', enviados: 4, assinados: 3, recusados: 1 },
  { day: '15/04', enviados: 6, assinados: 5, recusados: 0 },
  { day: '18/04', enviados: 3, assinados: 2, recusados: 1 },
  { day: '20/04', enviados: 8, assinados: 7, recusados: 0 },
  { day: '22/04', enviados: 5, assinados: 4, recusados: 0 },
  { day: '25/04', enviados: 9, assinados: 7, recusados: 1 },
  { day: '27/04', enviados: 6, assinados: 5, recusados: 0 },
  { day: '28/04', enviados: 4, assinados: 2, recusados: 0 },
];